import React from 'react';
import MemberCard from "./MemberCard.js";

const OtherMembersList = ({members, type, admin, childrenAndMember}) => {
  const memberCard = members.map(member => <MemberCard key={member.id} member={member} positions={[]} canEdit={admin || childrenAndMember.includes(member.id)} />);
  return (
    <>
      <section className="SectionContainer shadow-sm">
        <header className="SectionHeader d-flex justify-content-between align-items-center">
          <h1>
            <span>{type.toUpperCase()}</span>
            <span className="ms-1">
              {
                admin && `(${members.length})` /// ${members.length} )`
              }
            </span>
          </h1>
        </header>
        <div className="SectionBody position-relative">
          <div className="container u-borderBottom">
            {memberCard.length === 0  && <p className="text-center fst-italic m-0 p-4">There are no Coaches</p> }
            <ul className={`row p-0 ${memberCard.length > 0 && "pb-2"} m-0 list-unstyled`}>
              {memberCard}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default OtherMembersList;
